import { SxProps, TableSortLabel, Theme } from "@mui/material";
import { SortData } from "src/hooks/use-sort";
import Iconify from "./iconify/iconify";
import { TruxTableCell } from "./trux-table-cell";

type SortedByProps<T> = {
  sortField?: keyof T,
  sortKey: keyof T,
  sortDirection: "asc" | "desc"
}

function SortedBy<T>({ sortField, sortKey, sortDirection }: SortedByProps<T>) {
  if (sortField === sortKey) {
    return <span>
      <Iconify icon={sortDirection === "asc" ? "" : ""} />
    </span>
  }
  return null;
}


export type SortableHeaderProps<T> = {
  sortKey?: keyof T,
  sortData?: SortData<T>,
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify',
  children: React.ReactNode,
  sx?: SxProps<Theme>
}

export function SortableHeader<T>({ align, sortKey, sx, sortData, children }: SortableHeaderProps<T>) {
  if (!sortData || !sortKey) {
    return <TruxTableCell align={align}>{children}</TruxTableCell>
  }
  return <TruxTableCell
    align={align}
  >
    <TableSortLabel
      sx={{ width: "100%", justifyContent: align }} // color: `${Colors.white} !important`
      active={sortKey === sortData.sortField}
      direction={sortData.sortDirection}
      onClick={() => sortData.setSortField(sortKey)}
      hideSortIcon>
      {children}
    </TableSortLabel>
  </TruxTableCell>
}